import type { CustomerType } from '@/types/storage';

export enum GA4Event {
  AddToCart = 'add_to_cart',
  RemoveFromCart = 'remove_from_cart',
  SelectItem = 'select_item',
  ViewCart = 'view_cart',
  BeginCheckout = 'begin_checkout',
  AddShippingInfo = 'add_shipping_info',
  AddPaymentInfo = 'add_payment_info',
  Purchase = 'purchase',
  Login = 'login',
  SignUp = 'sign_up',
  SignUpToNewsletter = 'sign_up_to_newsletter',
  SendGiftCheckbox = 'send_gift_checkbox',
  SendGiftPurchase = 'send_gift_purchase',
  InfoPage = 'info',
  CheckoutError = 'checkout_error',
  AbTests = 'ab_test',
}

export type BaseItem = {
  item_id: string;
  item_name: string;
  item_brand?: string;
  itemCategory?: string;
  itemCategory2?: string;
  itemCategory3?: string;
  price?: string;
  quantity?: number;
};

export type ProductItem = BaseItem & {
  item_list_name: string;
  index?: number;
  item_variant?: string;
  item_coupon?: string;
};

export enum ProductType {
  CART_ITEM = 'CART_ITEM',
  PRODUCT_ITEM = 'PRODUCT_ITEM',
  PURCHASE_ITEM = 'PURCHASE_ITEM',
}

export interface LoginParams {
  user_id?: string;
  method?: string;
}

export interface EventParams extends LoginParams {
  event_label?:
    | 'cart popup'
    | 'cart page'
    | 'login page'
    | 'shipping/payment page'
    | 'register page';
  content_group?: string;
  user?: {
    id?: string;
    status?: string;
    type?: string;
    user_hash_email?: string;
    user_hash_name?: string;
    user_hash_surname?: string;
    user_hash_phone?: string;
    user_hash_city?: string;
    user_hash_address?: string;
    user_hash_zip?: string;
    customer_type?: CustomerType;
  };
  errorMessage?: string;
  ab_test?: string;
}

export type PaymentInfoExtraParams = {
  payment_type?: string;
  shipping_tier?: string;
};

export type CheckoutExtraParams = {
  currency: string;
  value: number;
  shipping: number;
  transaction_id: string;
  coupon: string;
};

export enum TestVariant {
  A = 'a',
  B = 'b',
}
